var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-label-champ mr-2"},[_c('div',{staticClass:"label-box-style ",class:_vm.classLabel},[(_vm.label)?_c('span',{staticClass:"title-tabel"},[_vm._v(_vm._s(_vm.label))]):_vm._e()]),_vm._t("body")],2)}
var staticRenderFns = []

export { render, staticRenderFns }